import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import AdminNavigation from '../navigation/AdminNavigation';
import { useAuth } from '@/context/AuthContext';
import { apiConfig } from '@/config/api';

const AdminLayout: React.FC = () => {
  const { user, loading } = useAuth();
  const location = useLocation();
  const [isRedirecting, setIsRedirecting] = React.useState(false);

  // Redirect to login if not authenticated
  React.useEffect(() => {
    if (!loading && !user) {
      setIsRedirecting(true);
      const next = encodeURIComponent(window.location.pathname + window.location.search);
      window.location.href = `${apiConfig.wwwUrl}/signin/?next=${next}`;
    }
  }, [loading, user]);

  // Check for admin role
  const isAdmin = user?.is_system_admin;

  if (loading || isRedirecting) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (!user || !isAdmin) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen">
        <h1 className="text-2xl font-bold text-red-600">Access Denied</h1>
        <p className="mt-2">You do not have permission to access admin tools.</p>
        <a href="/dashboard" className="mt-4 text-blue-600 hover:underline">Return to Dashboard</a>
      </div>
    );
  }

  return (
    <>
      <AdminNavigation />
      <Outlet />
    </>
  );
};

export default AdminLayout;
